import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "about",
  class: "pt-8 md:pt-12 pb-12 md:pb-16 bg-gray-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container mx-auto px-4 sm:px-6" }, [
      _createElementVNode("div", { class: "grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-xl sm:text-2xl md:text-2xl lg:text-3xl font-bold mb-4 text-primary" }, "Why We Started Safari Strives"),
          _createElementVNode("div", { class: "mb-6 md:mb-8" }, [
            _createElementVNode("h4", { class: "text-lg sm:text-xl md:text-xl font-bold mb-2 md:mb-3 text-primary" }, "Vision"),
            _createElementVNode("p", { class: "text-sm sm:text-base md:text-base text-gray-700 leading-relaxed text-justify" }, "To build a world in which economic independence enables individuals and communities to make informed choices, achieve sustainable development, and enjoy a higher quality of life.")
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", { class: "text-lg sm:text-xl md:text-xl font-bold mb-2 md:mb-3 text-primary" }, "Mission"),
            _createElementVNode("p", { class: "text-sm sm:text-base md:text-base text-gray-700 leading-relaxed text-justify" }, "To build enterprises that create formal jobs and invest capital in women entrepreneurs so that work in their communities leads to income, security, and ownership.")
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", { class: "rounded-lg overflow-hidden bg-black shadow-lg" }, [
            _createElementVNode("div", { class: "aspect-video" }, [
              _createElementVNode("iframe", {
                src: "https://www.youtube.com/embed/njiqUJcuVc4",
                class: "w-full h-full",
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: "",
                loading: "lazy"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}